<template>
    <div v-if="imageList" class="image-content">
        <p class="image-title">{{ title }}</p>

        <div class="image-list" ref="imageWrap" :class="{'image-over-auto': imageList.length > 2}">
            <div class="image-item" v-for="(_,i) in imageList" :key="i">
                <img class="image" :src="_.img_url" alt="">
                <img v-if="readonly" @click.stop="$emit('removeImageToList',_)" :src="require('@/assets/images/hvac/mapping/reduce-icon.png')" alt="" class="remove-icon">
            </div>

            <VantUploader :afterRead="uploadImageToList" v-if="readonly" :maxCount="1" class="image-item">
                <img class="icon" :src="require('@/assets/images/hvac/mapping/image-add-icon.png')" alt="">
            </VantUploader>

        </div>

    </div>
</template>

<script>
import {uploadImage} from "@/js/hvac/mapping";
import {Uploader} from 'vant';

export default {
    name: "position-load-image",
    components: {
        VantUploader: Uploader,
    },
    props: {
        title: {
            type: String,
            default: '位置照片'
        },
        // 是否只读
        readonly: Boolean,
        // 图片列表
        imageList: {
            type: Array,
            default: () => ([])
        }
    },
    methods: {
        /**
         * 添加一张图片
         */
        async uploadImageToList({content} = {}) {
            const {data: {result: {media_url, local_url: img}}} = await uploadImage({file: content});
            this.$emit('uploadImageToList', {
                img,
                img_url: media_url
            });
        },

    }
}
</script>

<style scoped lang="scss">

.image-content {

    .image-title {
        font-size: $smallSize;
        color: $deepGreen;
    }


    .image-list {
        display: flex;
        align-items: center;
        padding-top: 16px;
        min-height: 164px;

        .image-item {
            flex: 0 0 148px;
            height: 148px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
            background: #F3F3F3;
            position: relative;

            img {
                max-width: 100%;
                height: 100%;
            }

            .icon {
                width: 46px;
                height: 46px;
            }

            .remove-icon {
                width: 32px;
                height: 32px;
                position: absolute;
                top: -16px;
                right: -16px;
            }

            &:last-child {
                margin-right: 0;
            }
        }


    }

    .image-over-auto {
        overflow-x: auto;
    }

}
</style>